// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocationGridItem-GridWrap-eBwqw {
  display: block;
  overflow: hidden;
  -webkit-transform: scale(1);
      -ms-transform: scale(1);
          transform: scale(1);
  -webkit-transition: .5s all ease-in-out;
  transition: .5s all ease-in-out;
  -webkit-transition: .5s all ease;
  -moz-transition: .5s all ease;
  -o-transition: .5s all ease;
  background-color: #ccc;
}

.PopularLocationGridItem-GridWrap-eBwqw:before {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgb(0 0 0 / 0%);
  z-index: 1;
  transition: .5s all ease;
  -webkit-transition: .5s all ease;
  -moz-transition: .5s all ease;
  -o-transition: .5s all ease;
}

.PopularLocationGridItem-GridWrap-eBwqw:hover:before {
  opacity: 0;
  filter: alpha(opacity=0);
  -khtml-opacity: 0;
  -moz-opacity: 0;
}

.PopularLocationGridItem-GridCol-OoqEk:hover .PopularLocationGridItem-GridWrap-eBwqw {
  -ms-transform: scale(1.1);
      transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
}

.PopularLocationGridItem-GridColZoom-Ertsv {
  overflow: hidden;
  display: block;
  position: relative;
  border-radius: 5px;
}

.PopularLocationGridItem-placeWrap-Q7Dl7 {
  position: absolute;
  top: 50%;
  left: 50%;
  color: var(--white-text);
  font-size: 20px;
  -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  z-index: 2;
  text-shadow: 2px 2px 2px #000;
}

.PopularLocationGridItem-GridCol-OoqEk {
  width: 25%;
  padding: 5px;
}

.PopularLocationGridItem-GridWrap-eBwqw {
  width: 100%;
  height: 220px;
  background-size: cover;
  background-position: top center;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(2) {
  width: 25%;
  clear: both;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(3) {
  position: absolute;
  width: 50%;
  top: 0;
  left: 25%;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(3) .PopularLocationGridItem-GridColZoom-Ertsv .PopularLocationGridItem-GridWrap-eBwqw {
  width: 100%;
  height: 330px;
  background-size: cover;
  background-position: top center;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(4) {
  position: absolute;
  width: 25%;
  top: 0;
  right: 0;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(5) {
  position: absolute;
  width: 25%;
  top: 170px;
  right: 0;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(6) {
  width: 25%;
  clear: both;
}

@media (max-width:767px) {
  .PopularLocationGridItem-GridCol-OoqEk {
    width: 100% !important;
    height: auto !important;
    position: static !important;
  }

  .PopularLocationGridItem-GridWrap-eBwqw {
    height: 250px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/PopularLocationGridItem/PopularLocationGridItem.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAAmB;MAAnB,uBAAmB;UAAnB,mBAAmB;EACnB,uCAA+B;EAA/B,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAqB;MAArB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,oCAAgC;MAAhC,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,mCAAmC;EACnC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".GridWrap {\n  display: block;\n  overflow: hidden;\n  transform: scale(1);\n  transition: .5s all ease-in-out;\n  -webkit-transition: .5s all ease;\n  -moz-transition: .5s all ease;\n  -o-transition: .5s all ease;\n  background-color: #ccc;\n}\n\n.GridWrap:before {\n  content: '';\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: rgb(0 0 0 / 0%);\n  z-index: 1;\n  transition: .5s all ease;\n  -webkit-transition: .5s all ease;\n  -moz-transition: .5s all ease;\n  -o-transition: .5s all ease;\n}\n\n.GridWrap:hover:before {\n  opacity: 0;\n  filter: alpha(opacity=0);\n  -khtml-opacity: 0;\n  -moz-opacity: 0;\n}\n\n.GridCol:hover .GridWrap {\n  transform: scale(1.1);\n  -webkit-transform: scale(1.1);\n  -moz-transform: scale(1.1);\n  -o-transform: scale(1.1);\n}\n\n.GridColZoom {\n  overflow: hidden;\n  display: block;\n  position: relative;\n  border-radius: 5px;\n}\n\n.placeWrap {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: var(--white-text);\n  font-size: 20px;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  z-index: 2;\n  text-shadow: 2px 2px 2px #000;\n}\n\n.GridCol {\n  width: 25%;\n  padding: 5px;\n}\n\n.GridWrap {\n  width: 100%;\n  height: 220px;\n  background-size: cover;\n  background-position: top center;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n\n.GridCol:nth-child(2) {\n  width: 25%;\n  clear: both;\n}\n\n.GridCol:nth-child(3) {\n  position: absolute;\n  width: 50%;\n  top: 0;\n  left: 25%;\n}\n\n.GridCol:nth-child(3) .GridColZoom .GridWrap {\n  width: 100%;\n  height: 330px;\n  background-size: cover;\n  background-position: top center;\n}\n\n.GridCol:nth-child(4) {\n  position: absolute;\n  width: 25%;\n  top: 0;\n  right: 0;\n}\n\n.GridCol:nth-child(5) {\n  position: absolute;\n  width: 25%;\n  top: 170px;\n  right: 0;\n}\n\n.GridCol:nth-child(6) {\n  width: 25%;\n  clear: both;\n}\n\n@media (max-width:767px) {\n  .GridCol {\n    width: 100% !important;\n    height: auto !important;\n    position: static !important;\n  }\n\n  .GridWrap {\n    height: 250px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GridWrap": `PopularLocationGridItem-GridWrap-eBwqw`,
	"GridCol": `PopularLocationGridItem-GridCol-OoqEk`,
	"GridColZoom": `PopularLocationGridItem-GridColZoom-Ertsv`,
	"placeWrap": `PopularLocationGridItem-placeWrap-Q7Dl7`
};
module.exports = ___CSS_LOADER_EXPORT___;
